/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ list: NonNullable<unknown> }} Mk_Cmp_Page_SourcesInputs */

const en_mk_cmp_page_sources = /** @type {(inputs: Mk_Cmp_Page_SourcesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sources: ${i?.list}. Anything we could not verify ourselves is written plainly as “not published”.`)
};

const id_mk_cmp_page_sources = /** @type {(inputs: Mk_Cmp_Page_SourcesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sumber: ${i?.list}. Klaim yang tidak bisa kami verifikasi sendiri ditulis apa adanya sebagai "tidak dipublikasikan".`)
};

/**
* | output |
* | --- |
* | "Sources: {list}. Anything we could not verify ourselves is written plainly as “not published”." |
*
* @param {Mk_Cmp_Page_SourcesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_page_sources = /** @type {((inputs: Mk_Cmp_Page_SourcesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Page_SourcesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_page_sources(inputs)
	return en_mk_cmp_page_sources(inputs)
});